<template>
    <l-marker :lat-lng="latLng">
        <slot />
    </l-marker>
</template>

<script>
import { LMarker } from "vue2-leaflet"

export default {
    components: { LMarker },
    props: {
        latLng: { type: [Array, Object] },
    },
}
</script>